/**
 * Outcomes que acepta el endpoint de drill-down
 * (`/client-groups/{uuid}/leads/by-outcome`) en el param `outcome`.
 *
 * Cualquier otro valor devuelve 400, asi que se valida antes de llamar y solo
 * se hacen clicables las tarjetas cuyo contador es uno de estos. `attempts`,
 * por ejemplo, no es un outcome: es el total.
 */
export const BALANCER_OUTCOMES = [
    "ok",
    "rejected",
    "duplicate",
    "error",
    "capped",
    "pending",
    "not_delivered_any",
];

export function isBalancerOutcome(value) {
    return BALANCER_OUTCOMES.indexOf(value) !== -1;
}
